module.exports = __webpack_public_path__ + "static/media/fbg.d4ffcdb5.jpg";